import { ReportType } from "../constants/system-constants";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";
import { Filter } from "../models/Filter";
import { HoursWorkedReport } from "../models/HoursWorkedReport";
import { convertMillisecondsToTime, getDatesBetween, getDayOfTheWeek } from "./DateUtils";

const calculateHoursWorked = (hours: string, minutes: string, seconds: string) : number => {
    return parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds)
}

const getHoursWorkedTotalRow = (translate: Translator, timeWorked: number, timeWorkedTillNow: number, hourWorkedPerson: any): HoursWorkedReport => {
    // Calculate the total hours worked and hours worked till now for the user
    const hoursWorked = convertMillisecondsToTime(timeWorked);
    const hoursWorkedTillNow = convertMillisecondsToTime(timeWorkedTillNow)

    // Added to the total to the report
    const displayName = hourWorkedPerson["mst-displayname"];
    return {
        id: hourWorkedPerson["id"],
        displayName: translate.byKeyFormatted(TranslationKeys.totalFor, [displayName]),
        hoursWorked: hoursWorked,
        hoursWorkedNow: hoursWorkedTillNow,
        isDefault: true,
    }
}

export const buildHoursWorkedDetails = (hourWorkedPerson: any, translate: Translator, hoursWorkedReport: HoursWorkedReport[], dateFilter: Filter) => {
    const selected = dateFilter.selected[0];
    const startDate = selected.value.split(';')[0];
    const endDate = selected.value.split(';')[1];
    const requestedDates: string[] = getDatesBetween(startDate, endDate);
    const dates: string[] = hourWorkedPerson["date-only"];
    let timeWorkedMilliseconds: number = 0, timeWorkedTillNowmilliseconds: number = 0;

    // Loop through the requested dates and add the hours worked for each day
    requestedDates.forEach((date) => {
        const dateIndex = dates.indexOf(date);
        const dayOfTheWeek: string = getDayOfTheWeek(new Date(date).getDay(), translate);

        // Check if the requested date is in the list of user dates
        if (dates.includes(date) && hourWorkedPerson['hours-worked'][dateIndex] && hourWorkedPerson['hours-worked-till-now'][dateIndex]) {
            const [hours, minutes, seconds] = hourWorkedPerson['hours-worked'][dateIndex].split(":");
            const [hoursTillNow, minutesTillNow, secondsTillNow] = hourWorkedPerson['hours-worked-till-now'][dateIndex].split(":");
            timeWorkedMilliseconds += calculateHoursWorked(hours, minutes, seconds);
            timeWorkedTillNowmilliseconds += calculateHoursWorked(hoursTillNow, minutesTillNow, secondsTillNow);

            hoursWorkedReport.push({
                id: hourWorkedPerson["id"],
                dayOfWeek: dayOfTheWeek,
                dateOnly: date,
                hoursWorked: hourWorkedPerson['hours-worked'][dateIndex],
                hoursWorkedNow: hourWorkedPerson['hours-worked-till-now'][dateIndex],
            });

            return;
        }

        // If the requested date is not in the list of user dates, that means the user did not work on that day
        hoursWorkedReport.push({
            id: hourWorkedPerson["id"],
            dayOfWeek: dayOfTheWeek,
            dateOnly: date,
            hoursWorked: "00:00:00",
            hoursWorkedNow: "00:00:00",
        })
    });

    const totalRow = getHoursWorkedTotalRow(translate, timeWorkedMilliseconds, timeWorkedTillNowmilliseconds, hourWorkedPerson);
    hoursWorkedReport.push(totalRow);
}

export const getItemPath = (reportType: string, all = false) => {
    let pathSegment;
    switch (reportType) {
        case ReportType.TRANSACTIONAL:
            pathSegment = all ? 'transaction-reports' : 'transaction-report';
            break;
        case ReportType.TIME_AND_ATTENDANCE:
            pathSegment = all ? 'time-attendance-reports' : 'time-attendance-report';
            break;
        default:
            pathSegment = 'report' 
            break;
    }
    return `/access-control/reports/${pathSegment}/`;
}